module.exports = __webpack_public_path__ + "static/media/amex.73c40641.svg";